import appVersion from "@/config/version";

/**
 * Extracts semver (major.minor.patch) from a git describe string or plain version.
 * Examples: "v1.1.6-26-gb26558af" → [1,1,6], "1.2.0" → [1,2,0]
 */
function parseSemver(version: string): [number, number, number] | null {
  const match = version.match(/v?(\d+)\.(\d+)\.(\d+)/);
  if (!match) {
    return null;
  }
  return [Number(match[1]), Number(match[2]), Number(match[3])];
}

/**
 * Returns true if the current app version is below the minimum required version.
 * Returns false if either version can't be parsed (fail open).
 */
export function isVersionOutdated(minVersion: string): boolean {
  const current = parseSemver(appVersion);
  const minimum = parseSemver(minVersion);
  if (!current || !minimum) {
    return false;
  }

  for (let i = 0; i < 3; i++) {
    if (current[i] < minimum[i]) {
      return true;
    }
    if (current[i] > minimum[i]) {
      return false;
    }
  }
  return false;
}
